import { GraphqlError, UNKNOWN_ERROR_TRANSLATION_KEY } from '@data-access/api/error';

// Re-exported so existing consumers can keep importing `GraphqlError` from
// `@data-access/graphql`. It lives in `@data-access/api/error` to avoid a circular
// dependency with feature libraries (e.g. feature/analytics).
export { GraphqlError } from '@data-access/api/error';

export function isApolloNetworkError(error: GraphqlError): boolean {
  return error instanceof GraphqlError && error.message === UNKNOWN_ERROR_TRANSLATION_KEY;
}
